<footer
  class="bg-[#EAEDEF] p-4 justify-center items-center w-full relative bottom-0 left-0 z-40 shadow-md"
>
  <p class="text-[#2368A2] font-semibold text-[14px] md:text-[16px] text-center sm:w-full md:w-auto">
    BuildXY |
    <a href="#" class="hover:underline text-[#2368A2]">Privacy Policy</a> |
    <a href="#" class="hover:underline text-[#2368A2]">Security</a> |
    <a href="#" class="hover:underline text-[#2368A2]">Give Feedback</a>
  </p>
  <p class="text-[#343A40] font-semibold text-[14px] md:text-[16px] text-center sm:w-full md:w-auto">© 2024 Rocksofttech. All Rights Reserved.</p>
</footer>
